import { Component } from '@theme/component';
/* global Fancybox */

if (!customElements.get('fancy-box-gallery')) {
  /**
   * @typedef {Object} Refs
   * @property {(HTMLImageElement | HTMLVideoElement)[]} [fancyBoxMedia]
   *
   * @extends {Component<Refs>}
   */
  class FancyBoxGallery extends Component {
    requiredRefs = ['fancyBoxMedia'];

    connectedCallback() {
      super.connectedCallback();
    }

    get media() {
      return (this.refs.fancyBoxMedia || [])
        .map((media) => this.mapMediaItem(media))
        .filter(Boolean);
    }

    mapMediaItem(media) {
      if (!(media instanceof HTMLElement)) return null;

      if (media.tagName === 'IMG') {
        return {
          src: media.currentSrc || media.src,
          type: 'image',
          caption: media.alt || '',
        };
      }

      if (media.tagName === 'VIDEO') {
        const source = media.querySelector('source');
        const src = media.currentSrc || media.src || source?.src;
        const poster = media.querySelector('img');
        const posterSrc = poster ? poster.currentSrc || poster.src : '';
        if (!src) return null;

        return {
          src,
          caption: media.getAttribute('aria-label') || media.getAttribute('title') || '',
          thumbSrc: posterSrc,
        };
      }

      return null;
    }

    open(startIndex = 0) {
      if (typeof Fancybox === 'undefined') {
        console.error('Fancybox is not defined.');
        return;
      }

      const media = this.media;
      if (!media.length) return;

      const dialog = this.getOpenDialog();

      if (dialog && dialog instanceof HTMLDialogElement) {
        dialog.close();
      }
      Fancybox.show(media, {
        startIndex,
        Html: {
          videoAutoplay: false,
          videoControls: true,
        },
        on: {
          destroy: () => {
            if (dialog && dialog instanceof HTMLDialogElement && !dialog.open) {
              dialog.showModal();
            }
          },
        },
      });
    }

    getOpenDialog() {
      return document.querySelector('dialog[open]');
    }
  }

  customElements.define('fancy-box-gallery', FancyBoxGallery);
}
